import { render, staticRenderFns } from "./analysis-registrations.vue?vue&type=template&id=086bfe50&scoped=true&"
import script from "./analysis-registrations.vue?vue&type=script&lang=js&"
export * from "./analysis-registrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086bfe50",
  null
  
)

export default component.exports